import React, { useEffect, useState } from "react";
import { keycloak, initializeKeycloak } from "../firebase"; // Import Keycloak authentication functions
import { useLocation } from "react-router-dom"; // For return URL handling
import '../styles/Auth.css';

const Login = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  // Get return URL from query parameters
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get('returnUrl');

  useEffect(() => {
    // Automatically redirect to Keycloak login when component mounts
    const redirectToKeycloak = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        // Ensure Keycloak is initialized
        await initializeKeycloak();
        
        // Check if user is already authenticated
        if (keycloak.authenticated) {
          // User is already logged in, redirect them to the app
          if (returnUrl) {
            window.location.href = decodeURIComponent(returnUrl);
          } else {
            window.location.href = '/';
          }
          return;
        }
        
        // Redirect to Keycloak login page
        await keycloak.login({
          redirectUri: window.location.origin + (returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : '')
        });
        
      } catch (error) {
        console.error("Error redirecting to Keycloak login:", error);
        setError("Unable to access login page. Please try again.");
        setIsLoading(false);
      }
    };

    redirectToKeycloak();
  }, [returnUrl]);

  // Show loading or error state while redirecting
  return (
    <div className="auth-container">
      <div className="auth-card">
        <img src="/logo_dark.svg" alt="Interpretos" className="auth-logo" />
        
        {isLoading ? (
          <>
            <h1 className="auth-title">Redirecting to Login...</h1>
            <p className="auth-subtitle">You will be redirected to the secure login page</p>
            <div className="loading-spinner" style={{
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #4299e1',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              animation: 'spin 1s linear infinite',
              margin: '20px auto'
            }} />
            <p style={{ fontSize: '14px', color: '#666', marginTop: '20px' }}>
              If you are not redirected automatically, please check your browser settings.
            </p>
          </>
        ) : (
          <>
            <h1 className="auth-title">Login Error</h1>
            {error && <p className="error-message">{error}</p>}
            <button 
              onClick={() => window.location.reload()} 
              className="btn-primary"
              style={{ marginTop: '20px' }}
            >
              Try Again
            </button>
          </>
        )}
      </div>
      
      {/* Add CSS animation for loading spinner */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Login;
